import React from 'react';
import ohsLegacyUrlParse from '../global/OhsLegacyUrlParse';

export function OhsLegacyModules() {
  ohsLegacyUrlParse();
  //
  return null;
}
